import './types';

interface NewsArticleData {
    slug: string;
    meta_title: string;
}

const hideElement = (element: HTMLElement | null): void => {
    if (element) {
        element.classList.add('d-none');
    }
};

const showElement = (element: HTMLElement | null): void => {
    if (element) {
        element.classList.remove('d-none');
    }
};

const getNavHeight = (): number => {
    const topMenuPromotional = document.querySelector<HTMLElement>('.top-menu-promotional-bar');
    const topMenu = document.querySelector<HTMLElement>('.top-menu');
    const navbar = document.getElementById('header-navigation-container');

    if (topMenuPromotional && topMenu && navbar) {
        return topMenuPromotional.offsetHeight + topMenu.offsetHeight + navbar.offsetHeight;
    }

    return (topMenuPromotional ? topMenuPromotional.offsetHeight : 30)
        + (topMenu ? topMenu.offsetHeight : 38)
        + (navbar ? navbar.offsetHeight : 67);
};

const initArticleContentInfiniteScroll = (): void => {
    const articleContainer = document.querySelector<HTMLElement>('.article-container');

    if (!articleContainer) {
        return;
    }

    const newsArticleId = parseInt(articleContainer.dataset.newsArticleId || '0', 10);
    const newsArticleMetaTitle = articleContainer.dataset.newsArticleMetaTitle || '';
    const nextNewsArticlesJson = articleContainer.dataset.nextNewsArticles || '[]';

    let nextNewsArticles: NewsArticleData[];

    try {
        const parsed = JSON.parse(nextNewsArticlesJson);
        nextNewsArticles = Array.isArray(parsed) ? parsed : [];
    } catch {
        nextNewsArticles = [];
    }

    if (!nextNewsArticles.length) {
        return;
    }

    const loadMoreButton = document.querySelector<HTMLElement>('.load-more-btn');

    if (!loadMoreButton) {
        return;
    }

    hideElement(loadMoreButton);

    const firstArticleHeading = document.querySelector<HTMLElement>('.news-title');
    const firstArticleId = firstArticleHeading?.getAttribute('id');

    let firstArticleMetaTitle: string | undefined;

    if (parseInt(firstArticleId || '0', 10) === newsArticleId) {
        firstArticleMetaTitle = newsArticleMetaTitle;
    }

    const EVENT_DELAY = 500;
    let isBelowLastArticle = false;
    let lastScrollTop = 0;

    // Use the Metafizzy InfiniteScroll library
    const infiniteScroll = new window.InfiniteScroll(articleContainer, {
        path() {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            return nextNewsArticles[(this as any).loadCount]?.slug;
        },
        append: '.article-component-inside',
        button: '.load-more-btn',
        status: '.page-load-status',
        history: 'push',
        scrollThreshold: 1000,
    });

    infiniteScroll.on('request', () => {
        hideElement(loadMoreButton);
    });

    infiniteScroll.on('history', (title: unknown) => {
        const newsArticle = nextNewsArticles.find((article) => article.meta_title === title);
        document.title = newsArticle ? newsArticle.meta_title : (firstArticleMetaTitle || document.title);
    });

    const scrollHandler = (): void => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const scrollSpeed = lastScrollTop === 0 ? 0 : scrollTop - lastScrollTop;

        const SCROLL_THRESHOLD = 250;

        if (scrollSpeed > SCROLL_THRESHOLD) {
            infiniteScroll.loadOnScroll = false;
            showElement(loadMoreButton);

            const articleLoaderStatus = document.querySelector<HTMLElement>('.page-load-status');

            if (articleLoaderStatus) {
                hideElement(articleLoaderStatus);
                window.removeEventListener('scroll', scrollHandler);
            }
        }

        lastScrollTop = scrollTop;
    };

    const isBelow = (): void => {
        const articlesProperties = articleContainer.getBoundingClientRect();
        isBelowLastArticle = articlesProperties.bottom < 1;
    };

    const scrollToNewestArticle = (): void => {
        if (!isBelowLastArticle) {
            return;
        }

        const newsArticleContents = document.querySelectorAll<HTMLElement>('.news-article-content');

        if (newsArticleContents.length === 0) {
            return;
        }

        const lastNewsArticle = newsArticleContents[newsArticleContents.length - 1];
        const lastArticleRect = lastNewsArticle.getBoundingClientRect();

        const navbarHeight = getNavHeight();
        const margin = 80;
        const extraHeight = navbarHeight + margin;
        const targetPosition = lastArticleRect.top + window.scrollY - extraHeight;

        window.scrollTo({
            top: targetPosition,
            behavior: 'instant' as ScrollBehavior,
        });
        infiniteScroll.loadOnScroll = false;
        hideElement(loadMoreButton);
    };

    setTimeout(() => {
        window.addEventListener('scroll', scrollHandler);
        window.addEventListener('scroll', isBelow);
        loadMoreButton.addEventListener('click', scrollToNewestArticle);
    }, EVENT_DELAY);

    infiniteScroll.on('append', () => {
        const loadEvent = new Event('infinite-scroll-append');
        window.dispatchEvent(loadEvent);
    });

    infiniteScroll.on('load', () => {
        if (infiniteScroll.loadCount % 3 === 0) {
            infiniteScroll.loadOnScroll = false;
            showElement(loadMoreButton);
        } else {
            infiniteScroll.loadOnScroll = true;
            hideElement(loadMoreButton);
        }

        window.tippy?.delegate('.article-container', {
            target: '.tippy-author',
            placement: 'bottom',
            interactive: true,
            appendTo: 'parent',
            onShow(instance) {
                const id = instance.reference.getAttribute('data-template');
                const template = id ? document.getElementById(id) : null;

                if (template) {
                    showElement(template);
                    instance.setContent(template);
                }
            },
        });
        window.addEventListener('scroll', scrollHandler);
        lastScrollTop = window.scrollY || document.documentElement.scrollTop;
    });
};

const initArticleContent = (): void => {
    if (typeof window.InfiniteScroll === 'undefined') {
        setTimeout(initArticleContent, 50);

        return;
    }

    initArticleContentInfiniteScroll();
};

if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', initArticleContent);
} else {
    initArticleContent();
}
